import {createAction} from 'redux-actions';
import stickerItemsRepositoryBuilder from "../../../domain/factories/StickerItemsRepositoryBuilder";
import {IStickerItem} from "./reducer";
import {AnyAction} from "redux";
import {batchActions} from "redux-batched-actions";
import Noty from "noty";


const namespace = 'STICKER_ITEM_ENTITIES';

export const stickerItemsLoadRequest: (data: { stickerId: string }) => AnyAction = createAction(`${namespace}/STICKER_ITEMS_LOAD_REQUEST`);
export const stickerItemsLoadSuccess: (data: { stickerId: string, stickerItems: IStickerItem[] }) =>
    AnyAction = createAction(`${namespace}/STICKER_ITEMS_LOAD_SUCCESS`);
export const stickerItemsLoadFailed: (data: { stickerId: string, error: Error }) => AnyAction = createAction(`${namespace}/STICKER_ITEMS_LOAD_FAILED`);


export const stickerItemDeleteRequest: (data: { stickerId: string, stickerItemId: string }) => AnyAction = createAction(`${namespace}/STICKER_ITEM_DELETE_REQUEST`);
export const stickerItemDeleteSuccess: (data: { stickerId: string, stickerItemId: string }) => AnyAction = createAction(`${namespace}/STICKER_ITEM_DELETE_SUCCESS`);
export const stickerItemDeleteFailed: (data: { stickerId: string, stickerItemId: string, error: Error }) => AnyAction = createAction(`${namespace}/STICKER_ITEM_DELETE_FAILED`);


export function loadStickerItems(stickerId: string) {
    return (dispatch) => {
        if (!stickerId) {
            return
        }

        dispatch(stickerItemsLoadRequest({stickerId}));
        return stickerItemsRepositoryBuilder.buildWithStickerId(stickerId)
            .search({per_page: 1000, page: 1}) // TODO: we assure that we dont support more that 1000 for now :(
            .then((response) => response.data)
            .then((stickerItems: IStickerItem[]) => {
                dispatch(stickerItemsLoadSuccess({stickerId, stickerItems}))
            })
            .catch((error) => {
                const actions = [stickerItemsLoadFailed({stickerId, error})];
                dispatch(batchActions(actions));
            });
    };
}

export function deleteStickerItem(stickerItem?: IStickerItem | null) {
    return (dispatch) => {
        if (!stickerItem) {
            return
        }

        const stickerId = stickerItem.sticker_id;
        const stickerItemId = stickerItem.id;
        dispatch(stickerItemDeleteRequest({stickerId, stickerItemId}));
        return stickerItemsRepositoryBuilder.buildWithStickerId(stickerId)
            .delete(stickerItem)
            .then(() => {
                dispatch(stickerItemDeleteSuccess({stickerId, stickerItemId}))
            })
            .catch((error) => {
                dispatch(stickerItemDeleteFailed({stickerId, stickerItemId, error}));
                new Noty({
                    type: 'error',
                    timeout: 3000,
                    text: `Failed deleting sticker item. ${error}`,
                }).show();
            });
    };
}


// export function loadStickerItem(stickerId, stickerItemId, options = {creatingScreen: ''}) {
//     return (dispatch, getState) => {
//         if (stickerId) {
//             dispatch(stickerLoadRequest());
//
//             const state = stickerStateSelector(getState());
//             // const isLogged = isCurrentUserLoggedSelector(getState());
//
//             const notificationModeAsleep = (new URL(String(document.location))).searchParams.get('mode') === 'asleep';
//             const requestParams = (state.password !== '' ? {password: state.password} : {}) as any;
//             const needSendNotification = !location.pathname.match('sticker-router') ? canSendNotification(stickerId) : false;
//             if (needSendNotification && !notificationModeAsleep) {
//                 requestParams.source = 'web';
//             }
//             stickerItemsRepositoryBuilder.buildWithStickerId(stickerId)
//                 .loadById(stickerItemId, requestParams)
//                 .then((response) => response.data)
//                 .then((stickerItem) => {
//                     if (needSendNotification) {
//                         notificationIsSent(stickerId);
//                     }
//                     if (stickerItem.from != null) {
//                         // const { stickerForAttach } = state;
//                         // if (stickerForAttach != null && stickerItem.id === stickerForAttach.id && isLogged && !stickerItem.is_my_llama) {
//                         //   dispatch(attachStickerToCurrentUser(stickerItem));
//                         // } else if (!stickerItem.is_my_llama && !location.pathname.match('sticker-router') && stickerItem.type === "GREETING") {
//                         //   dispatch(setScanCongratulationsVisibility(true));
//                         //   // dispatch(startAttachingTimer(sticker));
//                         // }
//                         if (!location.pathname.match('sticker-router')) {
//                             dispatch(push(`/sticker-router/${stickerId}`));
//                         }
//                         dispatch(batchActions([
//                             stickerLoadSuccess(stickerItem),
//                             loadComments(stickerItem)
//                         ]));
//                     } else {
//                         dispatch(setScannedStickerRequest());
//                         cacheManager.getCachedSticker(stickerItem.id)
//                             .then((cachedStickerItem: any) => {
//                                 if (cachedStickerItem && cachedStickerItem.media) {
//                                     dispatch(showContinueOrFreshModal(cachedStickerItem));
//                                 } else {
//                                     dispatch(batchActions([
//                                         setScannedSticker(stickerItem),
//                                         push(`/${stickerItem.id}/${options.creatingScreen}`)
//                                     ]));
//                                 }
//                             });
//                     }
//                 })
//                 .catch((error) => {
//                     const actions = [stickerLoadFailed(error)];
//                     switch (error.code) {
//                         // Show password error
//                         case StickerLoadErrorCodeEnum.PasswordNotCorrect:
//                             actions.push(setFormErrors({password: error.code}));
//                             break;
//                         case StickerLoadErrorCodeEnum.StickerNotFound:
//                             actions.push(setFormErrors({notFound: true}));
//                             if (getState().router.location.pathname !== '/scan-sticker') {
//                                 actions.push(replace('/'))
//                             }
//                             break;
//                         // Show password modal
//                         case StickerLoadErrorCodeEnum.PasswordRequired:
//                             actions.push(setPasswordModalVisibility(true));
//                             break;
//                         default:
//                             actions.push(setFormErrors({server: true}));
//                             break;
//                     }
//
//                     dispatch(batchActions(actions));
//                 });
//         } else {
//             // todo throw error
//         }
//     };
// }



// WEBPACK FOOTER //
// ./src/app/modules/stickers/store/entities/sticker-items/actions.ts